'use client';

import Toggle from 'components/Faq/Toggle';
import TabItem from 'components/shared/Tabs/TabItem';
import { ToggleMenuProps } from './types';
import { startTransition, useState } from 'react';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { StyleVariant } from './constants';

const ToggleMenu = ({ variant = StyleVariant.Default, toggleItems, sys, color }: ToggleMenuProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index: number) => {
    startTransition(() => {
      setActiveIndex(index);
    });
  };

  return (
    <div className="mt-6 md:mt-14">
      {toggleItems.length > 1 && (
        <div {...liveUpdateAttrs(sys?.id, 'content')}>
          <div className="md:flex md:flex-row md:w-max bg-mint rounded-md">
            {toggleItems.map((item, i) => (
              <TabItem
                isActive={i === activeIndex}
                id={item.tabCopy}
                key={`tab-item-${item.tabCopy}-${i}`}
                onClick={() => handleClick(i)}>
                {item.tabCopy}
              </TabItem>
            ))}
          </div>
        </div>
      )}
      {toggleItems.map((item, i) => (
        <div key={`toggle-item-${item.tabCopy}-${i}`} hidden={i !== activeIndex}>
          <Toggle
            sys={item.sys}
            tabCopy={item.tabCopy}
            accordionItems={item.contentCollection}
            color={color}
            variant={variant}
          />
        </div>
      ))}
    </div>
  );
};

export default ToggleMenu;
